import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../contexts/context';

// Material UI
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import {useTheme} from '@mui/styles';

import {DEMO_MODE_INFO_TEXT, useExitDemoMode} from './cards/DemoModeCard';

// Same information as the DemoModeCard, but opened from the app bar icon. Used on
// the data (form) screen, where the card itself is not shown.
const DemoModeDialog = () => {
  const [ state, dispatch ] = useContext(AppContext);
  const [ open, setOpen ] = useState(false);
  const theme = useTheme();
  const exitDemoMode = useExitDemoMode();

  const handleClose = () => {
    dispatch({type: 'app/ui/dialog/default/close'});
  };

  const handleExitDemoMode = () => {
    exitDemoMode();
    handleClose();
  };

  useEffect(() => {
    setOpen(state.uiDialog === 'demomode');
  }, [state.uiDialog]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-demo">
      <DialogTitle
        id="form-dialog-demo"
        variant="h6"
        sx={{display: "flex", alignItems: "center", gap: 1.5}}
      >
        <Avatar sx={{bgcolor: "#fff", padding: 0.9}} aria-label="status_icon">
          <VideogameAssetIcon sx={{fontSize: 50, color: theme.palette.primary.main}}/>
        </Avatar>
        Demo mode is enabled
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {DEMO_MODE_INFO_TEXT}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleExitDemoMode} color="primary">
          Exit Demo Mode
        </Button>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DemoModeDialog;
